module.exports = __webpack_public_path__ + "img/shop-by-sedan.dec3925e.png";